import { useRecoilState, atom } from "recoil";

import appConfig from "../config/app.config";
import { API_STATUS } from "../constants/app.constants";
import useRestApiCall from "../http.interceptor";


const { LOADING, SUCCESS, ERROR } = API_STATUS;

const PRODUCT_LIST_INITIAL_STATE = {
    status: LOADING,
    content: null
};

const productsListStateAtom = atom({
    key: "productsListState",
    default: PRODUCT_LIST_INITIAL_STATE,
});

const apiListPayload = (params) => {
    let apiPayload = {
        method: "GET",
        url: "api/auth/list",
        baseURL: appConfig.apiMarketplaceBaseUrl,
        headers: {
            "Accept-Control-Allow-Origin": "*"
        },
        params
    };
    return apiPayload;
}


const useCategoyToProductsList = () => {

    const [apiList, setApiList] = useRecoilState(productsListStateAtom);
    const { apiCall } = useRestApiCall();
    const { status, content } = apiList;

    const fetchCategoryToProductsList = async () => {
        const params = {categoryType: "iot"};
        const payload = apiListPayload(params);
        try {
            const response = await apiCall(payload);
            if (response?.data) {
                let apiProducts = {...response.data };
                setApiList({ status: SUCCESS, content: apiProducts });
                return apiProducts;
            }
            throw new Error(response);
         }
        catch (error) {
            setApiList({ status: ERROR, content: error })
        }
    }

    const clearApiList = () => {
        setApiList(PRODUCT_LIST_INITIAL_STATE);
    }

    return { status, content, fetchCategoryToProductsList , clearApiList };

}

export default useCategoyToProductsList;